/**
 * Chat-style bubble used for the scrollback transcript and for in-card agent
 * copy. Agent side is carnival-amber/left; user side is slate/right.
 * Voice-tone: sparse, friendly, SMS-reply style (see SMART-IMPORT-COPY.md).
 */

import { motion } from 'framer-motion'
import type { ReactNode } from 'react'

interface AgentBubbleProps {
  from: 'agent' | 'user'
  children: ReactNode
}

export function AgentBubble({ from, children }: AgentBubbleProps) {
  const isAgent = from === 'agent'
  return (
    <motion.div
      initial={{ opacity: 0, y: 4 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.18 }}
      className={`flex w-full ${isAgent ? 'justify-start' : 'justify-end'}`}
    >
      <div
        className={
          isAgent
            ? 'max-w-[85%] rounded-2xl rounded-bl-sm bg-carnival-100 px-4 py-2 text-sm text-carnival-800 shadow-sm dark:bg-carnival-400/20 dark:text-carnival-100'
            : 'max-w-[85%] rounded-2xl rounded-br-sm bg-slate-200 px-4 py-2 text-sm text-slate-700 shadow-sm dark:bg-slate-700 dark:text-slate-200'
        }
      >
        {children}
      </div>
    </motion.div>
  )
}
